package com.hyperether.goodjob.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
expect fun getPlatformScale(): Float

val LocalScaleFactor = compositionLocalOf { 1f }

val WEB_SCREEN_SIZE_LIMIT = 1440.dp

val scale: Float
    @Composable get() = LocalScaleFactor.current

@Composable
fun Int.toScaleDp(): Dp = (this * scale).dp

@Composable
fun Float.toScaleDp(): Dp = (this * scale).dp

@Composable
fun Int.toScaleSp(): TextUnit = (this * scale).sp

@Composable
fun Float.toScaleSp(): TextUnit = (this * scale).sp